import { render } from "./cart-area.vue?vue&type=template&id=08988cf3&scoped=true"
import script from "./cart-area.vue?vue&type=script&lang=js"
export * from "./cart-area.vue?vue&type=script&lang=js"

import "./cart-area.vue?vue&type=style&index=0&id=08988cf3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08988cf3"]])

export default __exports__